/*****************************
* environment.js
* path: '/environment.js' (root of your project)
******************************/

import Constants from "expo-constants";

const ENV = {
 dev: {
   apiUrl: 'https://tfn63m71p8.execute-api.ap-southeast-2.amazonaws.com/TestingPartners/',
   //amplitudeApiKey: null,
   awsConfig : {
    region: "ap-southeast-2",
    userPoolId: "ap-southeast-2_VATDjFJDJ",
    userPoolWebClientId: "78cichht9unskkf626a9rp8qop",
    // "oauth": {
    //   "domain": "testaura12371-1231.auth.us-east-2.amazoncognito.com",
    //   "scope": [
    //       "phone",
    //       "email",
    //       "openid",
    //       "profile",
    //       "aws.cognito.signin.user.admin"
    //   ],
    //   "redirectSignIn": "http://localhost:19006/",
    //   "redirectSignOut": "http://localhost:19006/",
    //   "responseType": "code"
    // },
  }
 },
 prod: {
  apiUrl: "https://ckycyg7tkf.execute-api.ap-southeast-2.amazonaws.com/v1/",
   //amplitudeApiKey: "[Enter your key here]",
   awsConfig : {
    region: "ap-southeast-2",
    userPoolId: "ap-southeast-2_uuLyDr7f7",
    userPoolWebClientId: "477h9r6qqo0mpj6an97dna5gp7",
    "oauth": {
      "domain": "auramobile.auth.ap-southeast-2.amazoncognito.com",
      "scope": [
          "phone",
          "email",
          "openid",
          "profile",
          "aws.cognito.signin.user.admin"
      ],
      "redirectSignIn": "aura://",
      "redirectSignOut": "aura://",
      "responseType": "code"
    },
  }
   // Add other keys you want here
 }
};

const getEnvVars = (env = 'production') => {
 // What is __DEV__ ?
 // This variable is set to true when react-native is running in Dev mode.
 // __DEV__ is true when run locally, but false when published.
 if (__DEV__) {
   return ENV.prod;
 } else if (env === 'preview') {
   return ENV.dev;
 } else if (env === 'production') {
   return ENV.prod;
 } else {
  return ENV.prod;
 }
};

export default getEnvVars;